import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { setLayerMetadata } from '../../layerMetadata'
import { findFeature } from '../../findFeature'

import { findVehicleMarker } from './findVehicleMarker'
import { updateVehicleFeature } from './updateVehicleFeature'

const nonblockingRender = createNonBlockingRenderByTime()

export const changelogUpdateVehicleFeatures = async (
  layer: VectorLayer<VectorSource>,
  markers: Record<string, uui.domain.ui.map.markers.Vehicle>,
  mapStyles: uui.domain.ui.map.markers.MapStyles['vehicle'],
  selection: Set<string>,
  markerIds: IterableIterator<string>,
) => {
  nonblockingRender.reset()

  for (const markerId of markerIds) {
    await nonblockingRender.next()

    const marker = findVehicleMarker(markers, markerId)
    if (!marker) {
      throw new Error(
        `Trying to update Vehicle feature with lat-lng: ${markerId} but no marker exist on the map`,
      )
    }

    const feature = findFeature(layer, marker.id)

    if (!feature) {
      throw new Error(
        `Trying to update Vehicle feature with lat-lng: ${marker.id} but no feature exist on the map`,
      )
    }

    const selected = selection.has(markerId)
    updateVehicleFeature(mapStyles, marker, feature, selected)
  }

  // update the stored collection
  setLayerMetadata(layer, 'selection', selection)
}
